import React from 'react'

import First from './Images/1.png'
import Second from './Images/2.png'
import Third from './Images/3.png'
import Forth from './Images/4.png'
import {GridList, GridListTile} from "@material-ui/core";

const images = [
    {
        src: First,
        cols: 1,
        alt: "Urolift"
    },
    {
        src: Second,
        cols: 1,
        alt: "Urolift"
    },
    {
        src: Third,
        cols: 1,
        alt: "Urolift"
    },
    {
        src: Forth,
        cols: 1,
        alt: "Urolift"
    },
]

const ImagesUroliftGallery = () => {
    return (
        <GridList cols={4}>
            {images.map(image => (
                <GridListTile key={image.src} cols={image.cols || 1}>
                    <img src={image.src} alt={image.alt}/>
                </GridListTile>
            ))}
        </GridList>
    )
}

export default ImagesUroliftGallery


// WEBPACK FOOTER //
// ./src/Components/Schokwave/ImagesUroliftGallery.js